import { useState } from "react";
import { Button, FormRow, TextField } from "@plataforma/design-system";
import type { Client } from "@plataforma/shared";
import { useAppConfig } from "../../app/config";
import { useClients } from "./api";
import "./clients.css";

export type ClientChoice = { kind: "existing"; client: Client } | { kind: "new"; name: string; phone: string } | { kind: "none" };

/** Escolha de cliente por busca, com cadastro de um novo no mesmo passo (nome e telefone). */
export function ClientPicker({ value, onChange, error }: { value: ClientChoice; onChange: (choice: ClientChoice) => void; error?: string | null }) {
  const { config } = useAppConfig();
  const term = config.settings.terms.client.singular.toLowerCase();
  const [query, setQuery] = useState("");
  const clients = useClients(query);

  if (value.kind === "existing") {
    return (
      <div className="ds-field">
        <span className="ds-field__label">{config.settings.terms.client.singular}</span>
        <div className="client-picker__picked">
          <span><strong>{value.client.name}</strong> <span className="ds-muted">· {value.client.phone}</span></span>
          <Button variant="quiet" onClick={() => onChange({ kind: "none" })}>Trocar</Button>
        </div>
      </div>
    );
  }
  if (value.kind === "new") {
    return (
      <div className="client-picker__new">
        <FormRow>
          <TextField label="Nome completo" required autoComplete="off" value={value.name} onChange={(event) => onChange({ ...value, name: event.target.value })} />
          <TextField label="Telefone / WhatsApp" type="tel" required autoComplete="off" value={value.phone} onChange={(event) => onChange({ ...value, phone: event.target.value })} error={error} />
        </FormRow>
        <Button variant="quiet" onClick={() => onChange({ kind: "none" })}>← Buscar {term} existente</Button>
      </div>
    );
  }
  return (
    <div>
      <TextField label={config.settings.terms.client.singular} type="search" autoComplete="off" placeholder="Buscar por nome ou telefone" value={query} onChange={(event) => setQuery(event.target.value)} error={error} />
      <div className="client-picker__results">
        {(clients.data ?? []).slice(0, 5).map((client) => (
          <button key={client.id} type="button" className="client-picker__option" onClick={() => onChange({ kind: "existing", client })}>
            <strong>{client.name}</strong>
            <span>{client.phone}</span>
          </button>
        ))}
        <button type="button" className="client-picker__option" onClick={() => onChange({ kind: "new", name: query.trim(), phone: "" })}>
          <strong>{query.trim() ? `＋ Cadastrar “${query.trim()}” como novo ${term}` : `＋ Cadastrar novo ${term}`}</strong>
        </button>
      </div>
    </div>
  );
}
